































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import InputMoney from '@/components/UI/input-money.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import {
  ProdutoTerapiaSimplificadaParmDTO,
  TerapiaSimplificadaParmDTO,
  UnidadesAcessosProdutosParmDTO,
} from '@/interfaces/therapy';
import {
  findSimpleTherapyById,
  getTherapyVolumeUnits,
  listActiveTherapies,
  listClientsAvailableSimpleTherapy,
  listNutritionOffers,
  listProductsSimpleTherapy,
  listTnDaysSimpleTherapy,
  saveOrUpdate,
  validUnitsClientsProductsAvailable,
} from '@/services/therapy';
import { ADMINISTRATION_WAYS_CENTRAL, ADMINISTRATION_WAYS_PERIPHERAL } from '@/settings/consts/prescription-params';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import { VueMaskDirective } from 'v-mask';
import Component from 'vue-class-component';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { Prop, Watch } from 'vue-property-decorator';
import UiAutocompleClientsSubsidiaries from '../UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '../UI/list-messages.vue';
import UiAutocompleteClinicStates from './autocomplete-clinic-states.vue';
import UiAutocompleteClinicsSituations from './autocomplete-clinics-situations.vue';
import UiRadioGroupsNPTs from './radiogroup-npts.vue';

@Component({
  components: {
    PermissionAuth,
    UiSelectClients,
    UiAutocompleClientsSubsidiaries,
    ListMessages,
    InputMoney,
    UiAutocompleteClinicsSituations,
    UiRadioGroupsNPTs,
    UiAutocompleteClinicStates,
  },
  directives: {
    currency: CurrencyDirective,
    mask: VueMaskDirective,
  },
})
export default class SimpleTherapyForm extends BaseComponent {
  @Prop()
  public id: number;

  isEdit = true;

  public $refs!: {
    form: HTMLFormElement;
  };

  public dto: any = {};

  products: any[] = [];
  productsSelec: any[] = [];
  productAdd: any = null;
  clientsUnits: any[] = [];
  clientsUnitsFiltered: any[] = [];
  clientsUnitsSelec: any[] = [];
  unitFilter: string = null;
  tndays: any[] = [];
  ofertas: any[] = [];
  volumeUnits: any[] = [];
  therapies: any[] = [];
  viaAdministracaoEnabled = true;

  loading = false;
  error = false;
  clinicSituations = [];
  NPT_EXCLUSIVA = 'E';
  VIA_PERIFERICA = ADMINISTRATION_WAYS_PERIPHERAL;
  VIA_CENTRAL = ADMINISTRATION_WAYS_CENTRAL;

  public prodHeaders: any[] = [];
  public prodHeadersSup: any[] = [
    { text: 'Produto', value: 'nomeProduto', sortable: true },
    { text: 'Quantidade', value: 'quantidade', sortable: false, width: '150px' },
    { text: 'Unidade de Medida', value: 'unidade', sortable: false, width: '120px' },
    { text: '', value: '', sortable: false, width: '40px' },
  ];
  public prodHeadersExc: any[] = [];

  public form: any = {
    valid: false,
    rules: {
      codigo: [(v) => !!v || 'Informe o Código da Fórmula'],
      nome: [(v) => !!v || 'Informe o Nome da Fórmula'],
      ativo: [(v) => v != null || 'Informe o Status'],
      administracao: [(v) => v != null || 'Informe a Via de Administração'],
      suplementar: [(v) => v != null || 'Informe o Tipo'],
      ofertas: [(v) => v != null || 'Informe o Oferta Nutricional'],
      idEstadoClinico: [(v) => v != null || 'Informe o Estado Clínico'],
      sitClinic: [(v) => (v != null && v.length > 0) || 'Informe uma ou mais Situações Clínicas'],
      quantidade: [(v) => !!v || 'Informe a Quantidade'],
      unidade: [(v) => v != null || 'Informe a Unidade'],
      composicao: [(v) => v != null || 'Informe a Composição'],
      terapiaProporc: [(v) => v != null || 'Informe a Fórmula'],
      percent: [(v) => v != null || 'Informe o Percentual'],
    },
  };

  maskProd = {
    currency: { prefix: '', suffix: '' },
    locale: 'pt-BR',
    precision: { min: 2, max: 2 },
  };

  maskPercent = {
    currency: { prefix: '', suffix: '%' },
    locale: 'pt-BR',
    precision: { min: 0, max: 0 },
  };

  prodsPagination = new PaginationSyncDTO();

  openCopyDialogFlag = false;
  idTherapyCopy = null;

  mounted() {
    this.dto.id = this.id;
    this.loadClientsUnits();
    this.loadTnDays();
    this.loadNutritionOffers();
    this.loadVolumeUnits();
    this.loadActiveTherapies();
    this.init();
    this.registerValidUnitsClientSubject();
  }

  private loadClientsUnits() {
    listClientsAvailableSimpleTherapy().subscribe((res) => {
      this.clientsUnits = res;
      this.clientsUnitsFiltered = res;
    });
  }

  private loadTnDays() {
    listTnDaysSimpleTherapy().subscribe((res) => {
      this.tndays = res;
      this.buildProdHeaders();
    });
  }

  buildProdHeaders() {
    this.prodHeadersExc = [{ text: 'Produto', value: 'nomeProduto', sortable: true }];
    this.tndays.forEach((d) => {
      this.prodHeadersExc.push({
        text: `Quantidade para ${d.nome}`,
        value: `qtde${d.id}`,
        sortable: false,
        width: '120px',
      });
    });
    this.prodHeadersExc.push(
      { text: 'Unidade de Medida', value: 'unidade', sortable: false, width: '120px' },
      { text: '', value: '', sortable: false, width: '40px' },
    );
  }

  private loadNutritionOffers() {
    listNutritionOffers().subscribe((res) => {
      this.ofertas = res;
    });
  }
  private loadActiveTherapies() {
    listActiveTherapies(this.dto.id).subscribe((res) => {
      this.therapies = res;
    });
  }

  private loadVolumeUnits() {
    this.addSubsc(
      getTherapyVolumeUnits().subscribe((res) => {
        this.volumeUnits = res;
      }),
    );
  }

  private init() {
    this.loading = true;
    listProductsSimpleTherapy().subscribe((res) => {
      this.loading = false;
      this.products = res;
    });
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public resetForm(): void {}

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }

  private addProd(productAdd?) {
    if (productAdd == null) {
      productAdd = this.productAdd;
    }
    if (!productAdd.quantidades) {
      productAdd.quantidades = [];
    }
    this.productsSelec.push(productAdd);
    this.products.splice(this.products.findIndex((p) => p.idProduto == productAdd.idProduto), 1);
    setTimeout(() => {
      this.productAdd = null;
    }, 50);
  }

  private deleteProd(prod) {
    this.products.push(prod);
    this.products.sort((p1, p2) => {
      if (p1.nomeProduto < p2.nomeProduto) {
        return -1;
      }
      if (p1.nomeProduto > p2.nomeProduto) {
        return 1;
      }
      return 0;
    });
    this.productsSelec.splice(this.productsSelec.findIndex((p) => p.idProduto == prod.idProduto), 1);
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');

    let parm = new TerapiaSimplificadaParmDTO();
    let form = this.dto;
    parm.id = form.id;
    parm.codigo = form.codigo;
    parm.nome = form.nome;
    parm.ativo = form.ativo;
    parm.npt = form.npt;
    parm.viaAdministracao = form.viaAdministracao;
    parm.ofertaNutricional = form.ofertaNutricional ? form.ofertaNutricional.id : null;
    parm.idEstadoClinico = form.idEstadoClinico;
    parm.idsSituacoesClinicas = [];
    this.clinicSituations.forEach((c) => {
      parm.idsSituacoesClinicas.push(c.id);
    });
    parm.produtos = [];

    this.productsSelec.forEach((p) => {
      let prod = new ProdutoTerapiaSimplificadaParmDTO();
      prod.idProduto = p.idProduto;
      prod.quantidades = [];
      if (parm.npt == this.NPT_EXCLUSIVA) {
        this.tndays.forEach((d) => {
          let q = p.quantidades[d.id];
          prod.quantidades.push({ diasTN: d.id, quantidade: q ? this.getValorSemMask(q) : 0 });
        });
      } else {
        prod.quantidades.push({ diasTN: null, quantidade: this.getValorSemMask(p.quantidades['null']) });
      }
      prod.idUnidadeMedida = p.idUnidadeMedida;
      parm.produtos.push(prod);
    });
    if (this.isVolumeAvailable()) {
      parm.idVolumeUnidade = form.idVolumeUnidade;
      parm.volumeQuantidade = this.getValorSemMask(form.volumeQuantidade);
    }
    parm.idsUnidadesClientes = this.clientsUnitsSelec.map((c) => c.id);

    saveOrUpdate(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show('Farmo Express salva com sucesso', 'success');
        this.$emit('save');
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }

  getValorSemMask(valor: string) {
    return parseCurrency(valor, this.maskProd);
  }

  getValorComMask(valor: Number) {
    if (!valor) {
      return valor;
    }
    return String(valor).replace('.', ',');
  }

  @Watch('clinicSituations')
  private clinicSituationsChange() {
    for (let i = 0; i < this.clinicSituations.length; i++) {
      let v = this.clinicSituations[i];
      if (typeof v === 'string') {
        this.clinicSituations[i] = String(v).toUpperCase();
      }
    }
  }

  @Watch('id', { immediate: true })
  private idOnChange(id) {
    if (!id) {
      return;
    }
    findSimpleTherapyById(id).subscribe((res) => {
      this.dto = { ...res };
      this.clientsUnitsSelec = res.unidadesCliente;
      this.productsSelec = [];
      this.dto.idVolumeUnidade = res.volumeUnidade ? res.volumeUnidade.id : null;
      this.dto.volumeQuantidade = res.volumeQuantidade ? this.getValorComMask(res.volumeQuantidade) : null;
      this.dto.viaAdministracao = res.viaAdministracao.id;
      this.dto.npt = res.npt.id;
      this.dto.idEstadoClinico = res.estadoClinico ? res.estadoClinico.id : null;
      this.sleepUntil(() => {
        return this.products && this.products.length;
      }, 180000).then(() => {
        this.loadProducts(res);
        this.clinicSituations = [...res.situacoesClinicas];
      });
    });
  }

  loadProducts(res) {
    res.produtos.forEach((pDto) => {
      let prod = this.products.filter((p) => pDto.idProduto == p.idProduto)[0];
      prod.quantidades = [];
      pDto.quantidades.forEach((q) => {
        prod.quantidades[q.diasTN] = this.getValorComMask(q.quantidade);
      });
      prod.idUnidadeMedida = pDto.unidadeMedida.id;
      this.addProd(prod);
    });
  }

  @Watch('clientsUnitsSelec')
  @Watch('productsSelec')
  private prodUniClienteChange() {
    let parm = new UnidadesAcessosProdutosParmDTO();
    parm.idsUnidades = this.clientsUnitsSelec.map((c) => c.id);
    parm.idsProdutos = this.productsSelec.map((p) => p.idProduto);

    if (!parm.idsUnidades.length || !parm.idsProdutos.length) {
      return;
    }
    this.execValidUnitsClientSubject$.next(parm);
  }

  private execValidUnitsClientSubject$: BehaviorSubject<any> = new BehaviorSubject(null);

  private registerValidUnitsClientSubject() {
    this.execValidUnitsClientSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(2000),
        switchMap((filter) => {
          return validUnitsClientsProductsAvailable(filter);
        }),
      )
      .subscribe(
        (res) => {
          let instance = this;
          let falta = false;
          let clientes = [];
          let produtos = [];
          let msg = '<ul>';
          res
            .filter((r) => r.produtosNaoDisponiveis.length > 0)
            .forEach((r) => {
              falta = true;
              clientes.push(r.unidade);
              msg += `<li><strong>${r.unidade.nome}</strong> não tem os produtos:<ul>`;
              r.produtosNaoDisponiveis.forEach((p) => {
                msg += `<li>${p.nome}</li>`;
                produtos.push(p);
              });
              msg += `</ul></li>`;
            });
          msg += `</ul>`;

          if (!falta) {
            return;
          }

          this.dialog.show(
            'alert',
            null,
            null,
            'Remover Unidade Cliente',
            function() {
              clientes.forEach((c) => {
                let index = instance.clientsUnitsSelec.findIndex((u) => u.id == c.id);
                if (index >= 0) {
                  instance.clientsUnitsSelec.splice(index, 1);
                }
              });
            },
            'Remover Produtos',
            function() {
              produtos.forEach((p) => {
                let index = instance.productsSelec.findIndex((ps) => ps.idProduto == p.id);
                if (index >= 0) {
                  instance.productsSelec.splice(index, 1);
                }
              });
            },
            msg,
            '550px',
          );
        },
        (error) => {},
      );
  }

  openCopyDialog() {
    this.idTherapyCopy = null;
    this.openCopyDialogFlag = !this.openCopyDialogFlag;
  }

  copyTherapy(idTherapyCopy) {
    this.openCopyDialogFlag = false;
    if (!idTherapyCopy) {
      return;
    }
    let prodsDel = [...this.productsSelec];
    prodsDel.forEach((p) => {
      this.deleteProd(p);
    });
    this.loader.start('Preparando cópia...');
    findSimpleTherapyById(idTherapyCopy).subscribe(
      (res) => {
        this.loader.stop();
        this.loadProducts(res);
        this.dto.idVolumeUnidade = res.volumeUnidade.id;
        this.dto.volumeQuantidade = this.getValorComMask(res.volumeQuantidade);
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      },
    );
  }

  prepareCopyThisTherapy() {
    this.dto.id = null;
    this.dto.nome = null;
    this.dto.codigo = null;
    this.loadActiveTherapies();
    this.toast.show('A cópia da Fórmula esta pronta para edição', 'success');
  }

  onNptChange(v) {
    if (v == this.NPT_EXCLUSIVA) {
      this.prodHeaders = this.prodHeadersExc;
      this.dto.viaAdministracao = this.VIA_CENTRAL;
      this.viaAdministracaoEnabled = false;
    } else {
      this.prodHeaders = this.prodHeadersSup;
      this.viaAdministracaoEnabled = true;
    }
  }

  @Watch('unitFilter')
  onUnitFilterChange(v) {
    this.onUnitFilterChangeTimeout(v);
  }

  unitFilterTimeout = null;
  onUnitFilterChangeTimeout(v) {
    clearTimeout(this.unitFilterTimeout);
    this.unitFilterTimeout = setTimeout(() => {
      this.clientsUnitsFiltered = this.clientsUnits.filter((cu) => !v || cu.nome.toLowerCase().indexOf(v) >= 0);
    }, 200);
  }

  isVolumeAvailable() {
    return !this.isContainsWater();
  }

  isContainsWater() {
    return this.productsSelec.filter((p) => p.agua).length;
  }
}
